import ProgressBar from '../ProgressBar';

export function ProgressTab({ 
  supporters, 
  hasSupported, 
  supporting, 
  showThanks, 
  handleSupport,
  STAGES,
  progressIndex,
  progressDetails,
  progressImages,
  setProgressDetails,
  setProgressImages,
  handleProgressIndexChange,
  handleSaveProgress,
  handleStageImageFile,
  user
}) {
  return (
    <div className="section-container">
      <div className="section-card-compact">
        <div className="progress-header">
          <h3 className="progress-title">TVBA Project Progress</h3>
          <div className="progress-supporters">
            <div className="supporters-count">
              <span className="supporters-number">{supporters}</span>
              {supporters === 1 ? 'supporter' : 'supporters'}
            </div>
            <button
              className={`btn-primary px-4 py-2 text-sm ${hasSupported ? 'opacity-60 cursor-not-allowed' : ''}`}
              onClick={handleSupport}
              disabled={hasSupported || supporting}
            >
              {hasSupported ? 'Supported' : (supporting ? 'Supporting…' : 'Support')}
            </button>
            {showThanks && (
              <span className="success-badge">Thank you for supporting!</span>
            )}
          </div>
        </div>
        <ProgressBar
          stages={STAGES}
          currentIndex={progressIndex}
          onChangeIndex={user ? handleProgressIndexChange : undefined}
          details={progressDetails}
          images={progressImages}
          interactive={!!user}
          maskCurrent={!user}
          showPercent={!!user}
        />
        {user && (
          <div className="progress-admin-controls">
            {STAGES.map((label, idx) => (
              <div key={label} className="progress-stage-container">
                <label className="form-label">{label} details</label>
                <input
                  className="form-input"
                  placeholder={`Notes for ${label}`}
                  value={progressDetails[idx] || ''}
                  onChange={(e) => {
                    const copy = [...progressDetails];
                    copy[idx] = e.target.value;
                    setProgressDetails(copy);
                  }}
                  onBlur={() => handleSaveProgress(progressDetails, progressImages)}
                />
                <label className="form-label mt-2">{label} image URL</label>
                <input
                  className="form-input"
                  placeholder="https://..."
                  value={progressImages[idx] || ''}
                  onChange={(e) => {
                    const copy = [...progressImages];
                    copy[idx] = e.target.value;
                    setProgressImages(copy);
                  }}
                  onBlur={() => handleSaveProgress(progressDetails, progressImages)}
                />
                <input
                  type="file"
                  accept="image/*"
                  className="form-file-input"
                  onChange={(e) => handleStageImageFile(idx, e.target.files?.[0])}
                />
                {progressImages[idx] && (
                  <img
                    src={progressImages[idx]}
                    alt={`${label} preview`}
                    className="progress-image-preview"
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
